import {ValidatorInterface} from "./../ValidatorInterface";
import AbstractValidatorSet from "./AbstractValidatorSet";

export default class NullValidatorSet extends AbstractValidatorSet {
	getValidators(): ValidatorInterface[] {
		return [];
	}
}
